export default {
      id: "cross-usage",
      viewBox: "0 0 36.83 36.83",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#cross",
      toString: function () {
        return this.url;
      }
    }